import { render } from "./DetailsBlog.vue?vue&type=template&id=1346f4e5&scoped=true"
import script from "./DetailsBlog.vue?vue&type=script&lang=js"
export * from "./DetailsBlog.vue?vue&type=script&lang=js"

import "./DetailsBlog.vue?vue&type=style&index=0&id=1346f4e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1346f4e5"]])

export default __exports__